import React, { } from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function SrTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Sales Return Type", field: "salesreturntype" },
    { label: "Sales Return Category", field: "salesreturncategory" },
    { label: " Sales invoice No.", field: "invoiceno" },
    { label: "Sales Return No", field: "salesreturnno" },
    { label: "Sales Return Date", field: "salesreturndate" },
    { label: "Company Name ", field: "companyname" },
    { label: "Warehouse Name", field: "warehousename" },
  ];


  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"SALES REJECTION"}
        apiField={"salesReturn"}
        addButton={"+ ADD"}
        createRoute={"/srCreate"}
        updateRoute={"/srView"}
        viewRoute={"/srView"}
      />
    </div>
  );
}

export default SrTable;
